/**
 * @author liqiuqi
 * @date 2022 2022/4/27 14:54
 */
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 获取新手详情状态
export function restAccountMytastTaskDetail() {
  return omniAxios({
    url: config.restAccountMytastTaskDetailPath,
    method: "get",
    params: {},
  });
}

// 关闭 新手任务 任务遮罩
export function restAccountMytastCloseMask({ taskType = "" }) {
  return omniAxios({
    url: config.restAccountMytastCloseMaskPath,
    method: "post",
    params: {
      taskType,
    },
  });
}

// 完成任务
export function restAccountMytastAdd({ taskType = "" }) {
  return omniAxios({
    url: config.restAccountMytastAddPath,
    method: "post",
    params: {
      taskType,
      source: "1",
    },
  });
}

// 遮罩状态 todo currently useless
export function restAccountMytaskGetMaskStatus() {
  return omniAxios({
    url: config.restAccountMytaskGetMaskStatusPath,
    method: "get",
    params: {},
  });
}

// 操作手册
export function restAccountManualTree() {
  return omniAxios({
    url: config.restAccountManualTree,
    method: "get",
    params: {},
  });
}

// 意见反馈
export function restAccountMytaskFeedback({ suggestion = "", contact = "" }) {
  return omniAxios({
    url: config.restAccountMytaskFeedbackPath,
    method: "post",
    params: {
      suggestion,
      contact,
    },
  });
}

// 操作手册详情
export function restAccountManualManualDetail(id, params) {
  return omniAxios({
    url: config.restAccountManualManualDetailPath + `/${id}`,
    method: "get",
    params,
  });
}
